import { IEntryRecordLabels, INamedEntityLabels, PropertyTranslator } from "./GenericTranslator";
import { IModelWithIntId, INamedEntity, IEnteredOn, EntityConstants } from "./GenericTypes";

export const apiKeysConstants: EntityConstants<ApiKey> = {
  resource: "api_keys",
  frontendIndexRoute: "apikeys",
  entitySingular: "API key",
  entityPlural: "API keys",
  icon: "key",
};

export interface ApiKey extends IModelWithIntId, INamedEntity, IEnteredOn {
  apiKey: string;
  readOnly: boolean;
}

export interface ApiKeyWriteModel extends Omit<ApiKey, "id, enteredOn"> {}

export const ApiKeyFieldLabels: PropertyTranslator<ApiKey> = {
  ...INamedEntityLabels,
  ...IEntryRecordLabels,
  id: "API key ID",
  apiKey: "API key",
  readOnly: "Read only",
} as const;
